import { Component, Input, OnInit ,ViewChild ,SimpleChanges, Output, EventEmitter} from '@angular/core';
import * as Highcharts from 'highcharts/highstock';
import { MatTableDataSource,MatSort, MatPaginator } from '@angular/material';
import { ReportService } from 'src/app/services/report.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2'
import HC_exporting from 'highcharts/modules/exporting';

HC_exporting(Highcharts);
export interface demo {}
@Component({
  selector: 'smart-report-flower-zone',
  templateUrl: './report-flower-zone.component.html',
  styleUrls: ['./report-flower-zone.component.scss','../report.component.scss']
})
export class  ReportFlowerZoneComponent implements OnInit {
  series_data:any=[]
  series_data_2:any=[]
  categorie_data:any=[]
  show_chart:boolean=false
  tableColumns: string[] = ['farm_name','month', 'year','plot_name', 'sum_good_data', 'sum_fail_data','sum_all_data', 'group_type',  ];
  dataSource: MatTableDataSource < demo >
  chartOptionsLeft:any=[]
  chartOptionsRight:any=[]
  highcharts: typeof Highcharts = Highcharts;
  data_table:any
  role:string=''
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() filter_date : any;
  @Input() farmId :string;
  @Input() zoneId :string;
  @Input() plotId :string;
  @Input() child_org :string;
  @Output() output = new EventEmitter<string>();
  constructor(
    private reportservice : ReportService,
    private spinner: NgxSpinnerService
  ) { 
    this.role = sessionStorage.getItem("role")
  }

  ngOnInit(): void {

  }
  canDownload(Title){
    let menudowload =[]
    if( this.role == 'admin' || this.role == 'farm_manager'){
        menudowload = [{
          text: 'downloadJPEG',
          onclick: function() {
            let time_now =new Date()
            let image_name = Title+'-'+(time_now.getDate() < 10 ? ('0'+time_now.getDate() ): time_now.getDate() )+'-'+((time_now.getMonth()+1) < 10 ? ('0'+(time_now.getMonth()+1) ): (time_now.getMonth()+1))+'-'+time_now.getFullYear()+'['+(time_now.getHours() < 10 ? ('0'+time_now.getHours() ): time_now.getHours() )+ '-' + (time_now.getMinutes() < 10 ? ('0'+time_now.getMinutes() ): time_now.getMinutes() )+"]"
              this.exportChart({
                type: 'image/jpeg',
                filename: image_name
            });
          }},{
          text: 'downloadPNG',
          onclick: function() {
              let time_now =new Date()
              let image_name = Title+'-'+(time_now.getDate() < 10 ? ('0'+time_now.getDate() ): time_now.getDate() )+'-'+((time_now.getMonth()+1) < 10 ? ('0'+(time_now.getMonth()+1) ): (time_now.getMonth()+1))+'-'+time_now.getFullYear()+'['+(time_now.getHours() < 10 ? ('0'+time_now.getHours() ): time_now.getHours() )+ '-' + (time_now.getMinutes() < 10 ? ('0'+time_now.getMinutes() ): time_now.getMinutes() )+"]"
                this.exportChart({
                  type: 'image/png',
                  filename: image_name
              });
          }}]
          if(document.fullscreenEnabled){
            menudowload.push('viewFullscreen')
          }
          return menudowload
    }else{
      if(document.fullscreenEnabled){
        menudowload.push('viewFullscreen')
      }
      return menudowload 
    }
  }
  async ngOnChanges(changes: SimpleChanges) {
    if(changes.farmId || changes.plotId || changes.zoneId || changes.filter_date){
      if((changes.farmId&& changes.farmId.firstChange == false )||
      (changes.zoneId&& changes.zoneId.firstChange == false )||
      (changes.plotId&& changes.plotId.firstChange == false )||
      (changes.filter_date&& changes.filter_date.firstChange == false )){
        this.spinner.show()
        this.GetReportFlowerZone()
      }
    }
  
  }


  GetReportFlowerZone(){
    let body ={
      farm_id: this.farmId,
      zone_id: this.zoneId,
      plot_id: this.plotId,
      child_org_id:this.child_org,
      year_month: this.filter_date,
      group_type: "Flower"
    }
  
    this.reportservice.getReportFlowerZone(body).subscribe(
      async result => {
        if (result.code == 200) {
        this.show_chart = true
        let sum_all_data = []
        let sum_good_data = []
        let sum_fail_data = []
        this.series_data =[]
        this.series_data_2=[]
        this.categorie_data=[]
        this.data_table = result.data.table
        this.dataSource = new MatTableDataSource(this.data_table);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (item:any, property) => {
          switch (property) {
            case 'month': return parseInt(this.format_month_number(item.month)) ;
            default: return item[property];
          }
        };
        this.output.emit(result.data.table)
        result.data.chart.map(item=>{
          this.categorie_data.push(item.farm_name+' / '+item.plot_name)
          sum_all_data.push(item.sum_all_data)
          sum_fail_data.push(item.sum_fail_data)
          sum_good_data.push(item.sum_good_data)
        })
        this.series_data.push({name:'ผลรวมดอกทั้งหมด',data:sum_all_data , color:'#509EE3',events:{legendItemClick: function() {return false;}}})
        this.series_data.push({name:'ผลรวมดอกดี',data:sum_good_data, color:'#88BF4D',events:{legendItemClick: function() {return false;}}})
        this.series_data.push({name:'ผลรวมดอกเสีย',data:sum_fail_data,color:'#EF8C8C',events:{legendItemClick: function() {return false;}}})
        this.series_data_2.push({name:'ผลรวมดอกดี',data:sum_good_data, color:'#88BF4D',events:{legendItemClick: function() {return false;}}})
        this.series_data_2.push({name:'ผลรวมดอกเสีย',data:sum_fail_data,color:'#EF8C8C',events:{legendItemClick: function() {return false;}}})
        this.ChartLeft('column','ภาพรวมปริมาณดอกทั้งหมด ดอกดี ดอกเสีย แต่ละแปลง การปลูกวนิลา','แปลง','จำนวน')
        this.ChartRight('column','เปอร์เซ็นดอกดี ดอกเสีย แต่ละแปลง การปลูกวนิลา','แปลง','เปอร์เซ็น')
        this.spinner.hide()
  
        }else{
          
          this.spinner.hide()
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาดในการเรียกข้อมูล',
            showConfirmButton: false,
            timer: 3000
          })
          this.data_table =[]
          this.categorie_data = []
          if(this.series_data.length !=0){
            for(let i = 0 ; i <this.series_data[0].data.length;i++){
              this.series_data[0].data[i] = 0
              this.series_data[1].data[i] = 0
              this.series_data[2].data[i] = 0
            }
          }
          if(this.series_data_2.length !=0){
            for(let i = 0 ; i <this.series_data_2[0].data.length;i++){
              this.series_data_2[0].data[i] = 0
              this.series_data_2[1].data[i] = 0
            }
          }
          this.dataSource = new MatTableDataSource(this.data_table);
          this.dataSource.paginator = this.paginator;
          this.ChartLeft('column','ภาพรวมปริมาณดอกทั้งหมด ดอกดี ดอกเสีย แต่ละแปลง การปลูกวนิลา','แปลง','จำนวน')
          this.ChartRight('column','เปอร์เซ็นดอกดี ดอกเสีย แต่ละแปลง การปลูกวนิลา','แปลง','เปอร์เซ็น')
        }
      }
    )
    }

 ChartLeft(type:string,Title:string,xTitle:string,yTitle:string){
  Highcharts.setOptions({
    lang: {
      thousandsSep: ','
    }
  });
  this.chartOptionsLeft= {   
    exporting: {
      enabled: this.canDownload(Title).length !=0 ? true:false,
      buttons: {
        contextButton: {
            menuItems: this.canDownload(Title)
        }
      }
    },
    chart: {
        type: type,
        style: {
          fontFamily: 'Kanit',
        },events: {
          beforePrint: function() {
            this.setSize(1000, null, false)
          },
          afterPrint: function() {
            this.setSize(null, null, false)
          }
        }
    },
     legend: {
       align: 'left',
       verticalAlign: 'top',
       itemMarginLeft: 10,
       itemMarginBottom: 10,
       
     },
    title: {
        text:Title,
        style: {
          fontSize:'15px'
        },
    },
    xAxis: {
       title: {
            text: xTitle
        },
        categories:this.categorie_data,
        crosshair: true,
    },
    yAxis: {
        min: 0,
        title: {
            text: yTitle
        },
    },
    tooltip: {
        headerFormat: '<span >{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b> {point.y} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
    },
    plotOptions: {
        column: {
            pointPadding: 0.1,
            borderWidth: 0
        }
    },

    series:this.series_data
   };
   
  }
 ChartRight(type:string,Title:string,xTitle:string,yTitle:string){
  Highcharts.setOptions({
    lang: {
      thousandsSep: ','
    }
  });
  this.chartOptionsRight= {   
    exporting: {
      enabled: this.canDownload(Title).length !=0 ? true:false,
      buttons: {
        contextButton: {
            menuItems: this.canDownload(Title)
        }
      }
    },
    chart: {
        type:type,
        style: {
          fontFamily: 'Kanit',
        },events: {
          beforePrint: function() {
            this.setSize(1000, null, false)
          },
          afterPrint: function() {
            this.setSize(null, null, false)
          }
        }
    },
     legend: {
       align: 'left',
       verticalAlign: 'top',
       itemMarginLeft: 10,
       itemMarginBottom: 10,
       
     },
    title: {
        text: Title,
        style: {
          fontSize:'15px'
        },
    },
    xAxis: {
       title: {
            text: xTitle
        },
        categories:this.categorie_data,
        crosshair: true,
    },
    yAxis: {

        min: 0,
        title: {
            text: yTitle
        },
    },
    rangeSelector: {
      allButtonsEnabled: true,
      selected: 1
    },
    tooltip: {
        headerFormat: '<span >{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y} ( {point.percentage:.2f}% )</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
    },
    plotOptions: {
        column: {
            pointPadding: 0.1,
            borderWidth: 0,
            stacking: 'percent'
        }
    },

    series:this.series_data_2
   };
   
  }
  format_month_thai(data){
    data.map(obj=>{
      switch (obj.month) {
        case 'January':
          obj.month = 'มกราคม'
          break;
        case 'February':
          obj.month = 'กุมภาพันธ์'
          break;
        case 'March':
          obj.month = 'มีนาคม'
          break;
        case 'April':
          obj.month = 'เมษายน'
          break;
        case 'May':
          obj.month = 'พฤษภาคม'
          break;
        case 'June':
          obj.month = 'มิถุนายน'
          break;
        case 'July':
          obj.month = 'กรกฎาคม'
          break;
        case 'August':
          obj.month = 'สิงหาคม'
          break;
        case 'September':
          obj.month = 'กันยายน'
          break;
        case 'October':
          obj.month = 'ตุลาคม'
          break;
        case 'November':
          obj.month = 'พฤศจิกายน'
          break;
        case 'December':
          obj.month = 'ธันวาคม'
          break;
      }
    })
    return data
  }
  format_month_number(data){
    switch (data) {
      case 'January':
        data = '0'
        break;
      case 'February':
        data = '1'
        break;
      case 'March':
        data = '2'
        break;
      case 'April':
        data = '3'
        break;
      case 'May':
        data = '4'
        break;
      case 'June':
        data = '5'
        break;
      case 'July':
        data = '6'
        break;
      case 'August':
        data = '7'
        break;
      case 'September':
        data = '8'
        break;
      case 'October':
        data = '9'
        break;
      case 'November':
        data = '10'
        break;
      case 'December':
        data = '11'
        break;
    }

  return data
  }


}
